var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadingGlucose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#a4c0c9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,188.63c-33.89,0-61.45-29.27-61.45-65.26C38.55,71.59,92,16.12,94.27,13.79a8,8,0,0,1,11.46,0c2.28,2.33,55.72,57.8,55.72,109.58C161.45,159.36,133.89,188.63,100,188.63Zm0-157.34C86.64,46.67,54.55,87.36,54.55,123.37c0,27.16,20.39,49.26,45.45,49.26s45.45-22.1,45.45-49.26C145.45,87.36,113.37,46.67,100,31.29Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadingGlucose);
export default __webpack_public_path__ + "static/media/Reading - Glucose.73433ded1e797ad3833e4e8495212681.svg";
export { ForwardRef as ReactComponent };